import { Box, Progress, Text } from '@mantine/core';
import { IconFlag, IconMapPin } from '@tabler/icons-react';
import { FC } from 'react';

import { HARVEST_PROOF_MAX_DISTANCE_METERS } from '../../utils/field-proximity';
import { formatProximityDistanceLabel, ProximityUi } from '../../utils/proximity-ui';

import classes from './proximity-indicator.module.css';

interface ProximityIndicatorProps {
  proximity: ProximityUi;
  isCloseEnough: boolean;
}

export const ProximityIndicator: FC<ProximityIndicatorProps> = ({
  proximity,
  isCloseEnough,
}) => {
  const distanceLabel = formatProximityDistanceLabel(proximity);

  const hint = isCloseEnough
    ? 'Validez la photo sur votre téléphone : elle sera envoyée automatiquement.'
    : proximity.meters === null
      ? 'En attente de votre position GPS.'
      : `Rapprochez-vous à moins de ${HARVEST_PROOF_MAX_DISTANCE_METERS} m pour activer l’appareil photo.`;

  return (
    <Box className={classes.root}>
      <Text className={classes.distance} fw={600} size="md" ta="center">
        {distanceLabel}
      </Text>
      <Box className={classes.barRow}>
        <IconMapPin color={proximity.color} size={26} stroke={1.75} />
        <Progress
          animated={proximity.meters === null}
          classNames={{
            root: classes.progressRoot,
            section: classes.progressSection,
          }}
          size="xl"
          styles={{
            section: { backgroundColor: proximity.color },
          }}
          value={proximity.meters === null ? 30 : proximity.value}
        />
        <IconFlag color={proximity.color} size={26} stroke={1.75} />
      </Box>
      <Text
        c={isCloseEnough ? 'teal' : 'dimmed'}
        size="md"
        ta="center"
      >
        {hint}
      </Text>
    </Box>
  );
};
